import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useSetVisibility = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  return useMutation(
    trpc.studysets.updateVisibility.mutationOptions({
      onSuccess: async (data) => {
        queryClient.invalidateQueries({
          queryKey: trpc.studysets.getById.queryKey({ id: data.id }),
        });
        toast.success("Study Set visibility updated");
      },
      onError: (error) => {
        console.error("Failed to update visibility", error);
        toast.error("Failed to update study set visibility");
      },
    }),
  );
};
